import { IconSymbol } from '@uhg-abyss/web/ui/IconSymbol';
import { Link } from '@uhg-abyss/web/ui/Link';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { useLagoon } from '../../hooks/useLagoon';
import { ConstantsLagoon } from '../ConstantsLagoon';
import { Markdown } from '../Markdown';
import {
  HealthGradesInfoModalStyled,
  HealthGradesStyled,
  StyledIcon,
} from './HealthGradesDisclaimer.styled';

export const HealthGradesDisclaimer = () => {
  const [isOpen, setIsOpen] = useState(false);
  const lagoonData = useLagoon('ui-messaging')();
  const healthGradesDisclaimerContentFull = lagoonData?.find(
    (item) => item.key === ConstantsLagoon.HEALTHGRADES.MODAL_DISCLAIMER_FULL
  );
  const { t } = useTranslation();

  return (
    <HealthGradesStyled>
      <StyledIcon
        icon="healthgrades"
        isScreenReadable
        size={111}
        title={t('HEALTH_GRADES_LOGO_TITLE')}
      />
      <Link
        css={{
          'abyss-link-root': {
            alignItems: 'center',
            display: 'inline-flex',
            fontSize: '$extraSmallText',
            lineHeight: '$sm',
            height: '13px',
            width: 'fit-content',
          },
        }}
        data-auto-testid="healthgrades-link-text"
        data-testid="healthgrades-link-text"
        fontWeight="bold"
        onClick={(ev) => {
          ev.stopPropagation();
          ev.preventDefault();
          setIsOpen(true);
        }}
      >
        {t('HEALTHGARDE_DISCLAIMER.LINK_TEXT')}
        <IconSymbol icon="chevron_right" size="$xs" />
      </Link>
      {/* eslint-disable-next-line custom-rules/modal-and-drawer-requires-title */}
      <HealthGradesInfoModalStyled
        header={t('HEALTHGARDE_DISCLAIMER.HEALTHGRADES_INFORMATION')}
        isOpen={isOpen}
        onClose={() => setIsOpen(false)}
      >
        <div>
          <Markdown
            options={{
              overrides: {
                Link: {
                  component: Link,
                },
              },
            }}
          >
            {healthGradesDisclaimerContentFull?.message ?? ''}
          </Markdown>
        </div>
      </HealthGradesInfoModalStyled>
    </HealthGradesStyled>
  );
};
